import { Component } from '@angular/core';
import { LayoutService } from './layout.service'
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { SessionHandler } from '../shared/services/session-handler.service';
import { TranslateService } from 'ng2-translate';
@Component({
    selector: 'my-app-layout',
    template: require('./layout.component.html'),
    styles: [require('./layout.component.scss')]
})
export class LayoutComponent {
    isLogin:boolean = true;
    constructor(public layoutService:LayoutService,private router: Router,private sessionHandler:SessionHandler,
        private translate: TranslateService){
        let country = this.sessionHandler.getItem("country");
        if(country == 'BE') {
            translate.addLangs(["English","French","German","Dutch"]);
        } else if(country == 'NL') {
            translate.addLangs(["English","Dutch"]);
        } else if(country == 'FR') {
            translate.addLangs(["English","French"]);
        } else if(country == 'DE') {
            translate.addLangs(["English","German"]);
        }
        let defaultLanguage = this.sessionHandler.getItem("defaultLanguage");
        if(defaultLanguage) {
            translate.use(defaultLanguage);            
        } else {
            this.sessionHandler.saveItem("defaultLanguage",'English');
            translate.setDefaultLang('English');
            translate.use('English');
        }
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/layout.component.ts